import { parsePhoneNumberFromString, validatePhoneNumberLength } from 'libphonenumber-js'
import type { CountryCode } from 'libphonenumber-js'

export function getPhoneValidationError(
  value: string,
  defaultCountry: CountryCode = 'UY'
): string | null {
  const phone = value.trim()
  if (!phone) return 'El teléfono es requerido.'

  const lengthError = validatePhoneNumberLength(phone, defaultCountry)
  if (lengthError === 'TOO_SHORT') {
    return 'El teléfono está incompleto; revisá la cantidad de dígitos para ese país.'
  }
  if (lengthError === 'TOO_LONG') {
    return 'El teléfono tiene demasiados dígitos para ese país.'
  }
  if (lengthError === 'INVALID_LENGTH') {
    return 'La cantidad de dígitos no es válida para ese país.'
  }
  if (lengthError === 'INVALID_COUNTRY') {
    return 'El código de país ingresado no es válido.'
  }
  if (lengthError === 'NOT_A_NUMBER') {
    return 'Ingresá un teléfono válido usando dígitos y el código de país.'
  }

  const parsedPhone = parsePhoneNumberFromString(phone, defaultCountry)
  if (!parsedPhone || !parsedPhone.isValid()) {
    return 'El prefijo o número no es válido para ese país.'
  }

  return null
}
